import { z } from 'zod';
import { MANUFACTURING_ORDER_CONSTRAINTS } from './constraints.js';
/** Trims, enforces the max length, and normalises blank/null/undefined to null. */
export const workOrderNoteSchema = z
    .string()
    .trim()
    .max(MANUFACTURING_ORDER_CONSTRAINTS.note.maxLength, `${MANUFACTURING_ORDER_CONSTRAINTS.note.label} must be ${MANUFACTURING_ORDER_CONSTRAINTS.note.maxLength} characters or fewer.`)
    .nullish()
    .transform((value) => (value == null || value === '' ? null : value));
//# sourceMappingURL=work-order-note.js.map